module.exports = __webpack_public_path__ + "img/47.79aabac3.webp";